























import { Component, Mixins, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'
import { ShouninTask } from '@/store/types'

@Component
export default class ShouninTaskCard extends Mixins(BaseComponent) {
  @Prop({
    default: () => {
      /** */
    }
  })
  protected task!: ShouninTask

  protected avatar: string | null = null

  protected get teishutsushaName(): string {
    return this.task && this.task.teishutsushaName ? this.task.teishutsushaName : ''
  }

  protected get teishutsushaNameInitial(): string {
    return this.teishutsushaName.substr(0, 1)
  }

  protected get teishutuGetsudoStr(): string {
    return `${this.task.getsudo.yearValue}年${this.task.getsudo.monthValue}月度`
  }

  protected openShounin(): void {
    if (this.task) {
      this.$router.push(
        `/teishutsu/${this.task.getsudo.yearValue}/${this.task.getsudo.monthValue}/${this.task.teishutsushaId}`
      )
    }
  }
}
